import React, { useEffect, useState } from "react";
import "../../UI-component/SpidButton/index.css";
import Guest from "../../Layouts/GuestLayout";
import { SpidAPI } from "../../Apis/SpidAPI";
import { FastIdAPI } from "../../Apis/FastIdAPI";
import { useNavigate } from "react-router-dom";

//For execute test SpidValidator
//  src="../assets/images/AgID.svg"
/**
 *
 */
const extraProviderList = {
  Validator: "Validator",
  //ValidatorLocal: "ValidatorLocal"
};

export default function AccessoServizi(props) {
  //const navigate = useNavigate()

  //DEVELOPMENT ONLY DONT OPTIMIZE
  const getToken = async () => {
    try {
      const baseUrl =
        "https://sso-stage.nemea.cloud/realms/spid/protocol/openid-connect/auth";
      const redirectUri = `${window.location.origin}/callback`;
      const uniqueId = `SPID-${Date.now()}.${Math.random()}`;

      // Genera PKCE verifier e challenge
      const codeVerifier = generateCodeVerifier();
      const codeChallenge = await generateCodeChallenge(codeVerifier);

      // Salva il code verifier e redirect URI per la callback
      localStorage.setItem("code_verifier", codeVerifier);
      localStorage.setItem("redirect_uri", redirectUri);

      const params = new URLSearchParams({
        response_type: "code",
        client_id: "account-console",
        state: uniqueId,
        redirect_uri: redirectUri,
        scope: "openid profile email phone",
        nonce: uniqueId,
        code_challenge: codeChallenge,
        code_challenge_method: "S256",
      });

      const finalUrl = `${baseUrl}?${params.toString()}`;
      console.log("Redirecting to:", finalUrl);

      window.location.href = finalUrl;
    } catch (err) {
      console.error("error during SPID redirect", err);
      alert("Errore durante il redirect SPID: " + err.message);
    }
  };

  function generateCodeVerifier() {
    const array = new Uint8Array(32);
    window.crypto.getRandomValues(array);
    return base64URLEncode(array);
  }

  function base64URLEncode(buffer) {
    return btoa(String.fromCharCode.apply(null, new Uint8Array(buffer)))
      .replace(/\+/g, "-")
      .replace(/\//g, "_")
      .replace(/=/g, "");
  }

  async function generateCodeChallenge(verifier) {
    const encoder = new TextEncoder();
    const data = encoder.encode(verifier);
    const digest = await window.crypto.subtle.digest("SHA-256", data);
    return base64URLEncode(digest);
  }

  // Aggiungi questo stato per gestire il form
  const [showLoginForm, setShowLoginForm] = useState(false);
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const handleAutoLogin = async (e) => {
    e.preventDefault();
    setError('');

    try {
      if (password !== process.env.REACT_APP_ADMIN_PASSWORD) {
        setError("Password non valida");
        return;
      }

      const res = await SpidAPI.autoLogin(false);
      const data = res.data;
      const token = data.access_token;

      if (!token) {
        setError("Unable to login. Please try after some time.");
        return;
      }

      localStorage.setItem("access_token", token);
      localStorage.setItem("user", JSON.stringify(data.user));
      sessionStorage.setItem("isLoggedIn", true);
      window.location.replace("/");

    } catch (err) {
      console.error("Errore durante l'auto-login:", err);
      setError("Errore durante il login automatico");
    }
  };

  //casuing equal key component error (just for testing purposes)
  const mappingProvider = () => {
    let ret = Object.entries(extraProviderList).map(function (_ref3) {
      const entityName = _ref3[0];
      const entityID = _ref3[1];
      const logo = "../assets/images/logo-agid-test.png";

      return {
        protocols: ["SAML"],
        entityName: entityName,
        entityID: entityID,
        logo: logo,
        active: true,
      };
    });

    return ret;
  };

  useEffect(() => {
    // Controlla se ci sono dati nella sessione
    const configuration = localStorage.getItem("configuration");
    const destination = localStorage.getItem("destination");
    const spidLoginData = localStorage.getItem("spid_login_data");

    /* if (configuration || destination || spidLoginData) {
      alert('Dati presenti in localStorage:\n\n' + 
            'Configuration: ' + configuration + '\n\n' + 
            'Destination: ' + destination + '\n\n' + 
            'SPID Login Data: ' + spidLoginData);
    } */

    // Verifica se siamo nella callback
    if (window.location.pathname === "/callback") {
      alert("Siamo nella callback");
      const urlParams = new URLSearchParams(window.location.search);
      const code = urlParams.get("code");
      const state = urlParams.get("state");
      const sessionState = urlParams.get("session_state");

      if (code) {
        alert(
          `Codice ricevuto: ${code}\nState: ${state}\nSession State: ${sessionState}`
        );

        // Recupera il verifier salvato
        const verifier = localStorage.getItem("code_verifier");
        if (verifier) {
          // Scambia il codice con il token
          exchangeCodeForToken(code, verifier);
        }
      }
    }
  }, []);

  // Aggiungiamo una funzione per recuperare la configurazione OpenID
  const getOpenIdConfiguration = async () => {
    try {
      alert("Recupero configurazione OpenID");
      const response = await fetch(
        "https://sso-stage.nemea.cloud/realms/spid/.well-known/openid-configuration"
      );
      const config = await response.json();
      alert("Configurazione recuperata: " + JSON.stringify(config, null, 2));
      return config;
    } catch (err) {
      alert("Errore nel recupero della configurazione: " + err.message);
      return null;
    }
  };

  // Funzione per scambiare il codice con il token
  const exchangeCodeForToken = async (code, verifier) => {
    try {
      alert("Scambio codice per token");
      const tokenEndpoint =
        "https://sso-stage.nemea.cloud/realms/spid/protocol/openid-connect/token";

      const params = new URLSearchParams({
        grant_type: "authorization_code",
        client_id: "account-console",
        code: code,
        redirect_uri: `${window.location.origin}/callback`,
        code_verifier: verifier,
      });

      const response = await fetch(tokenEndpoint, {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: params,
      });

      const tokens = await response.json();
      alert("Token ricevuti: " + JSON.stringify(tokens, null, 2));
      return tokens;
    } catch (err) {
      alert("Errore nello scambio del codice: " + err.message);
      return null;
    }
  };

  return (
    <Guest
      auth={props.auth}
      errors={props.errors}
      key={Math.random() * 31 * Math.random() * 11}
    >
      <div className="container" id="main-container">
        <div className="row">
          <div className="col-12 col-lg-10 offset-lg-1">
            <div className="cmp-breadcrumbs" role="navigation">
              <nav className="breadcrumb-container" aria-label="breadcrumb">
                <ol className="breadcrumb p-0" data-element="breadcrumb">
                  <li className="breadcrumb-item">
                    <a href="/">Home</a>
                    <span className="separator">/</span>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Accedi
                  </li>
                </ol>
              </nav>
            </div>{" "}
            <div className="cmp-heading pb-3 pb-lg-4">
              <h1 className="title-xxxlarge">Accedi</h1>

              <p className="subtitle-small">
                Per accedere al sito e ai suoi servizi, utilizza il pulsante "Accedi all'area personale" in alto a destra.
              </p>
            </div>
          </div>
        </div>
        <hr className="d-none d-lg-block mt-0 mb-4" />

        {process.env?.REACT_APP_AUTOLOGIN === "true" && (
          <div className="row justify-content-center mt-4">
            <div className="col-12 col-md-6 col-lg-4">
              <div className="card">
                <div className="card-body">
                  <form onSubmit={handleAutoLogin}>
                    <div className="form-group mb-3">
                      <input
                        type="password"
                        className={`form-control ${error ? 'is-invalid' : ''}`}
                        placeholder="Password amministratore"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                      />
                      {error && (
                        <div className="invalid-feedback">
                          {error}
                        </div>
                      )}
                    </div>
                    <button
                      type="submit"
                      className="btn btn-primary w-100"
                    >
                      <svg className="icon icon-white me-2" aria-hidden="true">
                        <use href="../assets/bootstrap-italia/dist/svg/sprites.svg#it-user"></use>
                      </svg>
                      Accesso
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>

      {/** <HelpBox
        helpBoxInfo={{
          muniQuestionLink:
            'https://stellanello.nemea.cloud/domande-frequenti/',
          muniHelpLink: 'https://stellanello.nemea.cloud/servizi/assistenza/',
          greenNumber: 'tel:+39 0182 668000',
          bookLink: 'https://stellanello.nemea.cloud/servizi/prenotazioni/',
          rDisservice: ''
        }}
      /> 
     */}
    </Guest>
  );
}
